import { FormName } from "../../types.js";
const getParsedDataFromLS = () => {
  if (typeof window === "undefined") {
    return void 0;
  }
  try {
    const value = window.localStorage.getItem(FormName.personalDetails);
    if (value !== null && value !== "undefined" && value !== "" && value.trim() !== "") {
      const returnValue = JSON.parse(value);
      if (typeof returnValue !== "object") {
        return void 0;
      }
      if (Object.values(returnValue).some((v) => typeof v !== "string")) {
        return void 0;
      }
      return returnValue;
    } else {
      return void 0;
    }
  } catch (error) {
    console.error(error);
  }
};
const writeUserDataToLS = (data) => {
  try {
    window.localStorage.setItem(FormName.personalDetails, JSON.stringify(data));
  } catch (error) {
    console.error(error);
  }
};
const removeUserDataFromLS = () => {
  try {
    window.localStorage.removeItem(FormName.personalDetails);
  } catch (error) {
    console.error(error);
  }
};
export {
  getParsedDataFromLS,
  removeUserDataFromLS,
  writeUserDataToLS
};
//# sourceMappingURL=customer-name-persistor.js.map
